import { render, staticRenderFns } from "./addSartifact.vue?vue&type=template&id=0c874ebc&scoped=true"
import script from "./addSartifact.vue?vue&type=script&lang=js"
export * from "./addSartifact.vue?vue&type=script&lang=js"
import style0 from "./addSartifact.vue?vue&type=style&index=0&id=0c874ebc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c874ebc",
  null
  
)

export default component.exports